import { Collapsible } from '../interfaces';

export class ComparabilitySearchMultiYear implements Collapsible {
  rangeType: string;
  rangeMin: number;
  rangeMax: number;
  rangeMedian: number;
  lowerQuartile: number;
  upperQuartile: number;
  testedParty: string;
  inRangeStatus: number;
  collapsed: boolean;
}
